module.exports = __webpack_public_path__ + "img/shopee_9thb_0004.1c57d102.png";